/**
 * Created by pmnia on 12/03/15.
 */
(function () {
    'use strict';
    angular
        .module('app.data')
        .run(restoreSession)
        .factory('loginServices', loginServices);


    restoreSession.$inject=['$rootScope', '$stateParams','loginServices'];
    /*@ngInject*/
    function restoreSession($rootScope, $stateParams, loginServices) {
        loginServices.loadSession($stateParams.cId, loginServices);

        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                if (toParams.cId !== fromParams.cId) { // CID have change
                    loginServices.loadSession(toParams.cId, loginServices);
                }
            }
        );

        $rootScope.$on('obt:TimeOut', function (event, data) {
            loginServices.removeSession(data.cId, loginServices);
        });
    }


    loginServices.$inject = ['queryservice', 'exception', 'sessionServices'];
    /*@ngInject*/
    function loginServices(queryservice, exception, sessionServices){


        var status={};
        return  {
            status:status,
            signIn: signIn,
            signOut: signOut,
            loadSession:loadSession,
            removeSession:removeSession,
            changePassword:changePassword,
            sendPassword:sendPassword
        };

        function signIn(items, cId) {
            var fctArgsJson={};
            if(items.fName){
                fctArgsJson.fName = items.fName;
            }
            if(items.fName){
                fctArgsJson.isCellPhone = items.isCellPhone;
            }
            fctArgsJson.email = items.email;
            fctArgsJson.password = items.password;
            fctArgsJson.cId = cId;
            fctArgsJson.loginToUi = 1;
            var fctName= "obtLoginHelper.login";
            var instance = this;
            return queryservice.callServer(fctName,fctArgsJson)
                .then(function(data){
                   console.log(data);
                  if(data && (data.isCPhone === true || data.fName === true) ){

                    return data;
                 }
                 else{

                     if(data && data.error === 0){
                         if (data.sessionId ) {
                             saveSession(data, instance);
                             return data;
                         } else {
                             return {isLogged: false, body: data.body, error : 1};
                         }
                     }else {
                         return {isLogged: false, body: data.body, error : 1};
                     }
                 }

                });
        }
        function loadSession(cId, instance){
            instance.status = sessionServices.getSession(cId);
        }
        function saveSession(data, instance){
            sessionServices.setSession(data);
            if(data && instance){
                instance.status = data;
                instance.status.isLogged = true;
            }
        }
        function removeSession(cId, instance){
            sessionServices.removeSession(cId, true);
            instance.status = null;
        }
        function signOut(sessionId, cId){
            if(!sessionId && this.status && this.status.sessionId){
                sessionId = this.status.sessionId;
                cId = this.status.cId;
            }
            if(!sessionId){
                return;
            }
            var fctArgsJson={};
            fctArgsJson.cId = cId;
            fctArgsJson.sessionId = sessionId;
            var fctName= "obtLoginHelper.logout";
            var instance = this;
            return queryservice.callServer(fctName,fctArgsJson)
                .then(function(response){
                    removeSession(cId, instance);
                    return response;
                })
                .catch(function (){
                    removeSession(cId, instance);
                    exception.catcher('"sign out" function failed')
                    });
        }
        function changePassword(currentPwd, newPwd, uId, cId){
            var args = {};
            args.currentPassword = currentPwd;
            args.newPassword = newPwd;
            args.uId = uId;
            args.cId = cId;
            return queryservice.callServer("obtLoginHelper.updatePassword", args, null);
        }

        function sendPassword(cId, args){
            args = args || {};
            args.cId = cId;
            return queryservice.callServer("obtLoginHelper.sendPassword", args, null);
        }
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/data/login.services.js
 ** module id = 167
 ** module chunks = 0
 **/